import React from "react";

function Header() {
  return (
    <div>
      <div className="container-fluid bg-light py-5">
        <div className="col-md-6 m-auto text-center wow animate__animated animate__fadeInDown animate__slower">
          <h1 className="h1 text-success">Contact Us</h1>
          <p>
            Proident, sunt in culpa qui officia deserunt mollit anim id est
            laborum. Lorem ipsum dolor sit amet.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Header;
